export default "__VITE_ASSET__iaVoLQKX__"